import type { OrganizationPopoverOptions } from "./organization-popover.type";

import { useTheme } from "@/services/theme";

export const useOrganizationPopoverZindex = ({
  zIndex,
}: OrganizationPopoverOptions) => {
  const theme = useTheme();

  if (zIndex === "layout") return theme.token.zIndexLayoutShell as number;

  return undefined; // default z-index
};
